<template>
    <cadastro-simples-form
        endpoint="grupo-pontuacao-aluno"
        rota-base="/admin/grupo-pontuacao-aluno"
        titulo-singular="Grupo de Pontuação de Aluno"
        :campos-extras='[{"campo":"descricao","label":"Descrição","tipo":"text","span":24}]'>
    </cadastro-simples-form>
</template>

<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
